"use client";

import type { FormEvent, ReactNode } from "react";
import {
  Button,
  Dialog,
  DialogBackdrop,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPortal,
  DialogTitle,
} from "@/ui";
import styles from "./ConfirmDialog.module.css";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: ReactNode;
  message: ReactNode;
  cancelLabel?: string;
  confirmLabel?: string;
  pending?: boolean;
}

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  pending = false,
}: ConfirmDialogProps) {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onConfirm();
  };

  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && !pending && onClose()}>
      <DialogPortal>
        <DialogBackdrop className={styles.backdrop} />
        <DialogContent size="sm" className={styles.content}>
          <form onSubmit={handleSubmit}>
            <DialogHeader>
              <DialogTitle>{title}</DialogTitle>
              <DialogDescription>{message}</DialogDescription>
              <DialogClose />
            </DialogHeader>
            <DialogFooter className={styles.footer}>
              <Button type="button" variant="secondary" onClick={onClose} disabled={pending}>
                {cancelLabel}
              </Button>
              <Button type="submit" autoFocus loading={pending}>
                {confirmLabel}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
